<template>
    <v-col :cols="cols" :sm="sm" :md="md" :lg="lg" :xl="xl">
        <div class="font-weight-regular body-2 text-no-wrap">
            {{title}}
            <v-tooltip v-if="$slots.tooltip" top>
                <template v-slot:activator="{ on }">
                    <v-icon class="grey--text" v-on="on">{{icon_help}}</v-icon>
                </template>
                <v-progress-circular
                        v-if="loading"
                        indeterminate
                        size="28"
                        width="2"
                        color="dark">
                </v-progress-circular>
                <div v-else-if="error">
                    Ошибка
                </div>
                <div v-else>
                    <slot name="tooltip"></slot>
                </div>
            </v-tooltip>
        </div>
        <div class="headline">
            <v-progress-circular
                    v-if="loading"
                    indeterminate
                    size="28"
                    width="2"
                    color="dark">
            </v-progress-circular>
            <div v-else-if="error">
                Ошибка
            </div>
            <div v-else-if="$slots.default">
                <slot></slot>
            </div>
            <div v-else>
                {{ +parseFloat(value).toFixed(2) }}<span class="text--secondary">{{suffix}}</span>
            </div>
        </div>
    </v-col>
</template>

<script>
    import {mdiHelpCircle} from "@mdi/js";

    export default {
        name: "TotalCell",
        data() {
            return {
                icon_help: mdiHelpCircle,
            }
        },
        props: {
            loading: {
                default: false
            },
            error: {
                default: false,
            },
            title: {
                default: ''
            },
            value: {
                default: 0
            },
            suffix: {
                default: ''
            },
            cols: {
                default: null,
            },
            sm: {
                default: null,
            },
            md: {
                default: null,
            },
            lg: {
                default: null,
            },
            xl: {
                default: null,
            },
        }
    }
</script>

<style scoped>

</style>